import { withStyles } from '@material-ui/core/styles';
import { variant } from '../../../materialConfig/customTypography';
import TableCell from '@material-ui/core/TableCell';

const borderRadius = '4px';
export const BaseTableCell = withStyles((theme) => ({
  head: {
    height: '45px',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.black,
    fontWeight: 500,
    fontSize: '14px',
    '&:first-child': {
      borderRadius: `${borderRadius} 0 0 ${borderRadius}`,
    },
    '&:last-child': {
      borderRadius: `0 ${borderRadius} ${borderRadius} 0`,
    },
  },
  body: {
    ...variant.smallText,
  },
  root: {
    padding: '0 10px',
    border: 0,
  },
}))(TableCell);
